import { useState } from 'react'
import type { Session } from '@supabase/supabase-js'
import { Bell } from 'lucide-react'
import { apiFetch } from '../services/api'

interface Props {
  session: Session
  onAccepted: () => void
}

export default function TermsGate({ session, onAccepted }: Props) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleAccept() {
    setLoading(true)
    setError('')
    try {
      await apiFetch('/account/accept-terms', session, { method: 'POST' })
      onAccepted()
    } catch {
      setError('Errore durante il salvataggio. Riprova.')
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/60 px-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8 flex flex-col gap-6">

        <div className="flex items-center gap-2">
          <Bell size={20} className="text-sky-600 shrink-0" />
          <span className="font-bold text-lg text-gray-900">Radar Concorsi</span>
        </div>

        <div>
          <h1 className="text-xl font-bold text-gray-900 mb-2">Termini di Servizio</h1>
          <p className="text-sm text-gray-600 leading-relaxed">
            Per continuare a usare Radar Concorsi, leggi e accetta i nostri{' '}
            <a
              href="/termini"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sky-600 hover:underline font-medium"
            >
              Termini di Servizio
            </a>
            {' '}e la{' '}
            <a
              href="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sky-600 hover:underline font-medium"
            >
              Privacy Policy
            </a>.
          </p>
        </div>

        {error && <p className="text-sm text-red-600">{error}</p>}

        <button
          onClick={handleAccept}
          disabled={loading}
          className="w-full bg-sky-600 hover:bg-sky-700 disabled:opacity-60 text-white font-semibold rounded-lg px-4 py-3 text-sm transition-colors"
        >
          {loading ? 'Salvataggio…' : 'Accetto i Termini di Servizio'}
        </button>

        <p className="text-xs text-gray-400 text-center leading-relaxed">
          Cliccando "Accetto" confermi di aver letto e accettato i Termini di Servizio e
          la Privacy Policy di Radar Concorsi.
        </p>
      </div>
    </div>
  )
}
